import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVenusMars, faVenus, faMars } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { HealthSystemDALEnumsAnimalGender } from '../api/HealthSystemApi';

interface AnimalGenderSelectProps {
  value: number;
  onAnimalGenderChange: (value: HealthSystemDALEnumsAnimalGender) => void;
  cssClass?: string;
  allowAny?: boolean;
}

const AnimalGenderSelect = ({ value, onAnimalGenderChange, cssClass, allowAny }: AnimalGenderSelectProps) => {
  const { t } = useTranslation();

  const handleGenderChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const genderValue = event.target.value as HealthSystemDALEnumsAnimalGender;

    //callback
    onAnimalGenderChange && onAnimalGenderChange(genderValue);
  };

  return (
    <FormControl className={cssClass} size="small">
      <InputLabel id="animalGenderLabel">{t('f-gender')}</InputLabel>
      <Select labelId="animalGenderLabel" id="animalGenderSelect" value={value} onChange={handleGenderChange}>
        {allowAny && (
          <MenuItem value={0} id="gen-any">
            {<FontAwesomeIcon icon={faVenusMars} size="1x" />}&nbsp;{t('f-any')}
          </MenuItem>
        )}
        <MenuItem value={10} id="gen-male">
          {<FontAwesomeIcon icon={faMars} size="1x" />}&nbsp;{t('f-gender-male')}
        </MenuItem>

        <MenuItem value={20} id="gen-female">
          {<FontAwesomeIcon icon={faVenus} size="1x" />}&nbsp;{t('f-gender-female')}
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default AnimalGenderSelect;
